import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { AppFormattedMessage } from '../../components/app-formatted-message/app-formatted-message';
import { useScreenSize } from '../../hooks';
import { LibraryResourceList } from './components/library-resource-list';
import { ModalTypeComponentMap } from './constants/modal-type-component-map.constant';
import { LibraryModalStore } from './store/library-modal.store';

export const LIBRARY_MOBILE_BREAKPOINT_PX = 720;

export const Library: FC = () => {
  const type = LibraryModalStore(({ type }) => type);
  const { width } = useScreenSize();
  const isMobile = width < LIBRARY_MOBILE_BREAKPOINT_PX;

  return (
    <div
      className={twMerge(
        'h-full w-full overflow-y-auto rounded-md bg-white p-4',
        !isMobile && 'shadow-sm',
      )}
    >
      <div className="mb-6 flex w-full flex-col items-center text-center">
        <span
          className={twMerge(
            'bg-[linear-gradient(133deg,_#475467_29.58%,_#101828_84.27%)] bg-clip-text font-bold text-transparent [-webkit-text-fill-color:transparent]',
            isMobile ? 'text-[48px]' : 'text-[36px]',
          )}
        >
          <AppFormattedMessage id="LIBRARY" />
        </span>
        <span className="mt-4 max-w-[390px] text-xs font-[450] leading-4 text-gray-600">
          <AppFormattedMessage id="LIBRARY_DESCRIPTION" />
        </span>
      </div>
      <LibraryResourceList />
      {ModalTypeComponentMap[type]}
    </div>
  );
};
